module.exports = __webpack_public_path__ + "static/media/correct-icon.01f5f815.svg";